export const PINTEREST_FORM_TITLE = 'Pinterest Ads Automation';
export const PINTEREST_SERVICE_PATH = '/services/pinterest';
/** Locale the Ad step requests the default pin text in. */
export const PINTEREST_PIN_TEXT_LOCALE = 'en';
